// @catalog F.006
// CompareSelector — botón cycle entre "Año anterior" / "Período anterior" / "Sin comparar".
import { Box } from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

export type CompareKey = "ly" | "prev" | "none";

interface CompareSelectorProps {
  value: CompareKey;
  onChange: (next: CompareKey) => void;
}

const OPTIONS: Array<{ key: CompareKey; label: string }> = [
  { key: "ly", label: "Año anterior" },
  { key: "prev", label: "Período anterior" },
  { key: "none", label: "Sin comparar" },
];

export function CompareSelector(props: CompareSelectorProps): JSX.Element {
  const { value, onChange } = props;
  const current = OPTIONS.find((o) => o.key === value) ?? OPTIONS[0];

  const handleClick = (): void => {
    const idx = OPTIONS.findIndex((o) => o.key === value);
    const nextIdx = (idx + 1) % OPTIONS.length;
    const next = OPTIONS[nextIdx];
    if (next) onChange(next.key);
  };

  return (
    <Box
      component="button"
      type="button"
      onClick={handleClick}
      aria-label={`Comparar con ${current?.label ?? OPTIONS[0]?.label}`}
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        padding: "6px 10px",
        border: "1px solid var(--border)",
        borderRadius: "7px",
        backgroundColor: "var(--surface)",
        color: "var(--ink-2)",
        fontSize: "12.5px",
        fontFamily: "inherit",
        cursor: "pointer",
        "&:hover": { backgroundColor: "var(--bg-2)" },
        "&:focus-visible": {
          outline: "2px solid var(--accent)",
          outlineOffset: "1px",
        },
      }}
    >
      <CalendarMonthIcon sx={{ fontSize: 14, color: "var(--ink-3)" }} />
      <Box component="span" sx={{ color: "var(--ink-3)" }}>
        vs.
      </Box>
      <Box component="strong" sx={{ color: "var(--ink-1)", fontWeight: 600 }}>
        {current?.label}
      </Box>
      <KeyboardArrowDownIcon sx={{ fontSize: 14, color: "var(--ink-3)" }} />
    </Box>
  );
}
